import { render, staticRenderFns } from "./item.vue?vue&type=template&id=428792c9"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428792c9')) {
      api.createRecord('428792c9', component.options)
    } else {
      api.reload('428792c9', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=428792c9", function () {
      api.rerender('428792c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/conversations/item.vue"
export default component.exports